import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { WEBINAR_LOGOS } from '../../data/webinarCommunications';
import { useWebinar } from '../../hooks/useWebinar';
export function WebinarNav() {
  const {
    copy,
    lang,
    setLang
  } = useWebinar();
  const c = copy.nav;
  return <header className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-b border-[#E4E6EC]" data-id="element-7930" data-mp="5mfdidg4r2tk">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between gap-4" data-id="element-7931" data-mp="12ad06u22nzps">
        <Link to="/" aria-label={c.home} className="flex items-center shrink-0" data-id="element-7932" data-mp="yal0z7ykj5x3">
          <img src={WEBINAR_LOGOS.bciti} alt="BCITI" className="h-14 w-auto object-contain" data-id="element-7933" data-mp="tib417z1d5lb" />
          <span className="mx-2.5 text-[#121212]/25 font-sans text-2xl font-light" aria-hidden="true" data-id="element-7934" data-mp="ol1dfozwunvw">|</span>
          <img src={WEBINAR_LOGOS.atna} alt="ATNA" className="h-12 w-auto object-contain" data-id="element-7935" data-mp="1m0fc9l38omf8" />
        </Link>
        <nav aria-label={c.aria} className="flex items-center gap-1 md:gap-2" data-id="element-7936" data-mp="1h85g3nbj6q4i">
          {c.links.map(l => <a key={l.href} href={l.href} className="hidden md:inline-flex px-3 py-2 font-sans text-sm text-[#121212]/65 hover:text-[#121212] transition-colors duration-150" data-id="element-7937" data-mp="3ixmhg2xa91lj">
              {l.label}
            </a>)}
          <div role="group" aria-label={c.langLabel} className="flex items-center font-sans text-[12.5px] font-semibold ml-1" data-id="element-7938" data-mp="3e64gvfz69313">
            {(['FR', 'EN'] as const).map((l, i) => <React.Fragment key={l} data-id="element-7939" data-mp="308fx6bguc1xm" data-mpi={i}>
                {i === 1 && <span className="text-[#121212]/20 px-0.5" aria-hidden="true" data-id="element-7940" data-mp="355pro5j373sb">|</span>}
                <button type="button" onClick={() => setLang(l)} aria-pressed={lang === l} className={`px-1.5 py-1 transition-colors duration-150 ${lang === l ? 'text-[#4F46E5]' : 'text-[#121212]/45 hover:text-[#121212]'}`} data-id="element-7941" data-mp="2r66kpg20hyhl">
                  {l}
                </button>
              </React.Fragment>)}
          </div>
          <a href="#inscription" className="ml-2 inline-flex items-center gap-2 rounded-full bg-[#4F46E5] px-4 md:px-5 py-2.5 font-sans text-sm font-semibold text-white hover:bg-[#4338CA] transition-colors duration-150 whitespace-nowrap" data-id="element-7942" data-mp="22dwp91zg5ev7">
            {c.register}
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-7943" data-mp="1oe44dnalpsv5" />
          </a>
        </nav>
      </div>
    </header>;
}